<template>
  <div class="mapway">
    <button @click="drawer = true">dianwo</button>
    <el-drawer title="" size='auto' :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <div id="map"></div>
      <!-- <div id="panel"></div> -->
    </el-drawer>

  </div>
</template>

<script>
  export default {
    props: {
      drawer: {
        type: Boolean,
        default: false,
      },
      destination: {
        type: Array,
        default: [],
      },
      startingPoint: {
        type: Array,
        default: [],
      }
    },
    data() {
      return {
        direction: 'ttb',
      }
    },
    watch: {
      drawer() {
        if (this.drawer) {
          this.$nextTick(() => {
            this.initMap();
          })
        }
        this.$emit('update:drawer', this.drawer);
      }
    },
    methods: {
      initMap() {
        this.map = new AMap.Map('map', {
          center: [110.79, 32.65],
          resizeEnable: true,
          zoom: 13,
        })

        // 监听地图点击坐标
        this.map.on('click', (e) => {
          this.mapclick = {
            lng: e.lnglat.getLng(),
            lat: e.lnglat.getLat()
          }
        })
        //添加地图控件
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.moveAnimation'], () => {
          this.map.addControl(new AMap.ToolBar())
          this.map.addControl(new AMap.Scale())
        })
        //构造路线导航类
        let driving = new AMap.Driving({
          map: this.map,
          // panel: "panel"
        });
        // 根据起终点经纬度规划驾车导航路线
        let lgtlnt = JSON.parse(localStorage.getItem('lgtlnt')) || {};
        let start= [lgtlnt.lng,lgtlnt.lat] || [110.79, 32.65];
        let end = this.destination;
        driving.search(new AMap.LngLat(...start), new AMap.LngLat(...end), (status,result)=>{
          // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          if (status === 'complete') {
            log.success('绘制驾车路线完成')
          } else {
            log.error('获取驾车数据失败：' + result)
          }
        });
      },
    }
  }
</script>

<style scoped>
  #map {
    width: 100%;
    height: 77.1rem;
    margin-bottom: 52px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/mapWay.vue